import * as Yup from 'yup';
import { DB_PREFIX, DB_PREFIX_INFO, DB_PREFIX_REGISTER } from './constants';

export default Yup.object().shape({
  [DB_PREFIX_REGISTER]: Yup.object().shape({
    registered: Yup.boolean().required(),
  }),
  [DB_PREFIX_INFO]: Yup.object().when(`${DB_PREFIX_REGISTER}.registered`, {
    is: true,
    then: Yup.object().shape({
      firstName: Yup.string().required('Please input your first name'),
      lastName: Yup.string().required('Please input your last name'),
      dateOfBirth: Yup.string()
        .nullable()
        .required('Please select your date of birth'),
    }),
    nationality: Yup.string().required('Required').nullable(),
  }),
  [DB_PREFIX]: Yup.object().when(`${DB_PREFIX_REGISTER}.registered`, {
    is: true,
    then: Yup.object().shape({
      id: Yup.string()
        .matches(
          /^00\d{10}$/,
          'The id needs to start with two 0 and be 12 digits long'
        )
        .required('required'),
      fileURL: Yup.string().url().required(),
      permissionToCheckDBS: Yup.boolean(),
    }),
  }),
});
